import React from 'react';
import parse from 'html-react-parser';
import { useInputNumberGroup } from '../hooks';
import InputNumber from 'rsuite/InputNumber';
import OptionTitle from 'components/OptionElements/OptionTitle';
import OptionDescription from 'components/OptionElements/OptionDescription';
import OptionPrice from 'components/OptionElements/OptionPrice';
import OptionImage from 'components/OptionElements/OptionImage';
import OptionVideo from 'components/OptionElements/OptionVideo';
import * as Utils from 'utils';

export default function OptionTypeInputNumberBanner(props) {
  const {options} = props;
  const [ , onChangeOptions ] = useInputNumberGroup(props);

  return (
    <div className="app-option-list">
      {options.map((option, optionIndex) => {
      const {
        id,
        title,
        description,
        priceTitle,
        quantityTitle,
        quantityValue,
        quantityValueMin,
        quantityValueMax,
        imageUrl,
        imageUrl2x,
        imageAlt,
        imageHeight,
        imageWidth,
        video = null,
        customClass = '',
        isDisabled = false
      } = option;

      return (
        <div className={`app-option-item ${customClass}`} key={id}>
          <OptionTitle title={title} />
          <OptionDescription description={description} />
          <OptionPrice
            priceTitle={priceTitle}
            priceValueText={Utils.replacer(option, 'priceValueText')}
          />
          <div className="app-option-input-number">
            {quantityTitle && <div>{parse(quantityTitle)}</div>}
            <InputNumber
              value={quantityValue}
              min={quantityValueMin}
              max={quantityValueMax}
              disabled={isDisabled}
              onChange={(value, event) => onChangeOptions(value, event, optionIndex)}
            />
          </div>
          {video
            ? <OptionVideo video={video} />
            : <OptionImage
                imageAlt={imageAlt}
                imageUrl={imageUrl}
                imageUrl2x={imageUrl2x}
                imageHeight={imageHeight}
                imageWidth={imageWidth}
              />
          }
        </div>
      )
    })}
    </div>
  )
}
